var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256c11.13,0,256-33.391,256-33.391L512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M0,256C0,114.616,114.616,0,256,0s256,114.616,256,256"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M357.616,176.644L256,278.261L154.384,176.644c-13.141,19.507-20.818,42.986-20.818,68.225v33.391 c0,53.616,34.645,99.289,82.722,115.82c-6.417,12.576-5.335,28.271,4.068,40.006c12.488-10.009,25.417-20.37,36.385-29.158 c10.968,8.789,23.898,19.15,36.385,29.158c9.513-11.872,10.517-27.802,3.847-40.452c47.42-16.89,81.461-62.228,81.461-115.374 V244.87C378.435,219.63,370.757,196.152,357.616,176.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,367.304c-49.099,0-89.043-39.945-89.043-89.043V244.87c0-49.099,39.945-89.043,89.043-89.043 s89.043,39.945,89.043,89.043v33.391C345.043,327.359,305.099,367.304,256,367.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M311.652,278.261V244.87c0-30.687-24.966-55.652-55.652-55.652s-55.652,24.966-55.652,55.652v33.391 L256,289.391L311.652,278.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M200.348,278.261L200.348,278.261c0,30.687,24.966,55.652,55.652,55.652s55.652-24.966,55.652-55.652 l0,0H200.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M322.783,155.826c0-18.441-14.95-33.391-33.391-33.391c-8.555,0-16.352,3.22-22.261,8.509v-19.64 h11.13V89.043h-11.13v-11.13H244.87v11.13h-11.13v22.261h11.13v19.64c-5.909-5.289-13.707-8.509-22.261-8.509 c-18.441,0-33.391,14.95-33.391,33.391c0,9.887,4.301,18.767,11.13,24.882v19.64h111.304v-19.64 C318.482,174.593,322.783,165.713,322.783,155.826z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.3115550839cc0538646d9b767691638f.svg";
export { ForwardRef as ReactComponent };